require('isomorphic-fetch');
require('es6-promise').polyfill();

const VERSIONS = [1];

let routes = {};
VERSIONS.forEach((version) => {
	routes[version] = require(`./version/${version}/global.json`);
});

class Skynet {

	constructor(apiBase = '//www.laithwaites.co.uk', version = 1, country) {
		this.routes = routes[version];
		this.apiBase = apiBase;
		this._setupRoutes();
	}

	_setupRoutes() {
		Object.keys(this.routes).forEach((key) => {
			this._setupRoute(this, this.routes, key);
		});
	}

	_setupRoute(target, definition, key) {
		if (definition[key].uri !== undefined) {
			target[key] = this._dispatch.bind(this, definition[key]);
		} else {
			target[key] = {};
			Object.keys(definition[key]).forEach((subkey) => {
				this._setupRoute(target[key],definition[key],subkey);
			});
		}
	}

	_dispatch() {
		let arg = arguments,
			route = arg[0],
			params,
			callback,
			uri;

		if (typeof arg[1] === 'function') {
			callback = arg[1];
		} else {
			params = arg[1];
			callback = arg[2];
		}

		// parse the URL for special params
		uri = route.uri.replace(/\{\{(.*?)\}\}/g, function (x) {
			var replaced = '';
			if (x) {
				x = x.replace('{{', '').replace('}}', '');
				// look in the params object
				route.params.forEach(function (param) {
					if (param.name === x && params[param.name]) {
						replaced = params[param.name];
						// remove all the params in the URL from the params 
						// object so they arent sent twice
						if (!param.body) {
							delete params[param.name];
						}
					}
				});
			}
			return replaced;
		});

		return this._request(
			route.method.toUpperCase(), 
			this.apiBase + uri, 
			params
		);
	}

	_serialize(obj) {
		const str = [];
		for (let p in obj) {
			if (obj.hasOwnProperty(p)) {
				str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
			}
		}
		return str.join('&');
	}

	_request(method, uri, params) {

		let options = {
			method: method,
			credentials: 'same-origin'
		}

		// if we have something in our params object
		if (JSON.stringify(params) !== JSON.stringify({})) {
			if (method.toUpperCase() === 'GET') {
				var serializedParams = this._serialize(params);
				if (serializedParams) {
					uri += '?' + this._serialize(params);
				}
			} else if (typeof params === 'object') {
				// JSON
				options.headers = {
					'Content-Type': 'application/json'
				};
				options.body = JSON.stringify(params);
			}
		}

		return fetch(uri, options);
	}
}

export default Skynet;
